module.exports = __webpack_public_path__ + "05_medium_brown.1e76f06e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer5/05_medium_brown.png
// module id = WO+o
// module chunks = 0